import { Button } from "@mui/material";
import { Box, styled } from "@mui/system";

// GLOBAL
export const MainBox = styled(Box)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "70vh",
})

// export const ExitButton = styled(Button)({
//     display: 'inline-block',
//     padding:0,
//     minHeight: 0,
//     minWidth: 0,
//     marginLeft: '290px',
//     '&.MuiButton-text': {
//         backgroundColor: 'transparent',
//     },
// })